import { render, staticRenderFns } from "./DeleteDraft.vue?vue&type=template&id=4307bd40&"
import script from "./DeleteDraft.vue?vue&type=script&lang=js&"
export * from "./DeleteDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports